var Alert;
(function (Alert) {
    Alert["ALLERGIES"] = "allergies";
    Alert["BIRTHDAY"] = "birthday";
    Alert["FALL_RISK"] = "fallRisk";
    Alert["ISOLATION"] = "isolation";
    Alert["PREVENTIVE_MEDICINE"] = "preventiveMedicine";
    Alert["VIP"] = "vip";
})(Alert || (Alert = {}));
export default Alert;
//# sourceMappingURL=alert.js.map